import axios from "axios";
import { GetLevels2 } from "./GetLevels2Action";
import {
  editLevel2Requested,
  editLevel2RequestSucceeded,
  editLevel2RequestFailed,
} from "../slices/EditLevel2Slice";

const selectedCountry = localStorage.getItem("selectedCountry");

const apiUrl = `${process.env.REACT_APP_BASE_API_URL}/api/Menu/EditLevel2`;

const ApiKey = process.env.REACT_APP_BASE_API_KEY;

const getSelectedCountryId = () => {
  const sessionData = localStorage.getItem("sesion");

  if (!sessionData || !selectedCountry) {
    return null;
  }

  const session = JSON.parse(sessionData);
  const country = (session.rols || [])
    .map((entry) => entry.country)
    .find((item) => item?.countryName === selectedCountry);

  return country?.idcountry ?? null;
};

const getSessionUserName = () => {
  const sessionData = localStorage.getItem("sesion");

  if (!sessionData) {
    return "";
  }

  const session = JSON.parse(sessionData);
  return session.employeeId || "";
};

export const EditLevel2 = (level2) => async (dispatch) => {
  try {
    dispatch(editLevel2Requested());

    const putData = {
      idmenuLevel2: Number(level2.idmenuLevel2),
      name: level2.name,
      isActive: level2.isActive ?? true,
      createdBy: level2.createdBy,
      createdDate: level2.createdDate,
      modifiedBy: getSessionUserName(),
      modifiedDate: new Date().toISOString(),
      idCountry: Number(level2.idCountry ?? getSelectedCountryId()),
    };

    const axiosConfig = {
      headers: {
        ApiKey: ApiKey,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(apiUrl, putData, axiosConfig);

    if (response.data === true) {
      dispatch(editLevel2RequestSucceeded(response.data));
      await dispatch(GetLevels2());
      return { success: true, message: "Category updated successfully" };
    }

    const errorMessage =
      "The category could not be updated. Please try again.";
    dispatch(editLevel2RequestFailed(errorMessage));

    return { success: false, message: errorMessage };
  } catch (error) {
    const errorMessage = error.response?.data || error.message;
    dispatch(editLevel2RequestFailed(errorMessage));

    return {
      success: false,
      message: errorMessage,
    };
  }
};
